// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3fmmS","name":"ConsentHeader_name__2CiLY","birthday":"ConsentHeader_birthday__SNCQy","skeleton":"ConsentHeader_skeleton__2Th9j"};